<script lang="ts">
	import { Button, Input, Toggle, Text } from '@Shelly/shelly-design-system';
	import { convertTime, getErrorOrInfoMessageForMinAndMax } from 'src/helpers/utilities';
	import { callBluTRV, getTrvComponentByDevice } from 'src/helpers/virtual_helpers/blutrv_helpers';
	import type { Device } from 'src/types/Device';
	import { format } from 'svelte-i18n';

	export let device: Device;
	let waitForResponse = false;

	let config = getTrvComponentByDevice(device)?.config?.['trv:0'];

	let default_override_duration = convertTime(config?.default_override_duration ?? 0, 'seconds');
	let default_override_target_C = config?.default_override_target_C ?? 0;
	let override_enable = config?.override_enable ?? false;

	$: minMaxInfo = getErrorOrInfoMessageForMinAndMax(
		Number(default_override_duration),
		0,
		35791394,
		false,
		true,
	);

	const handleOpenWindowTarget = async () => {
		if (default_override_duration === '') {
			default_override_duration = 0;
		}
		waitForResponse = true;

		await callBluTRV(device, 'Trv.Setconfig', {
			id: 0,
			config: {
				default_override_duration: convertTime(default_override_duration, 'minutes'),
				default_override_target_C,
				override_enable,
			},
		});
		waitForResponse = false;
	};
</script>

<div class="d-flex flex-direction-column">
	<Toggle
		class="mb-s"
		loading={waitForResponse}
		disabled={waitForResponse}
		size="m"
		bind:checked={override_enable}
		id="toggle-bvzw3r8"
	>
		{$format('toggle_enable_temp_override', {
			default: 'Enable temperature override',
		})}
	</Toggle>

	<Text class="mb-s" element="span" styleType="body-extra-small"
		>{$format('text_trv_setting_temperature', { default: 'Temperature' })}</Text
	>
	<Input
		aria-label={$format('input_temp_override_open_window', {
			default: 'Enter the temperature override when window is open in °C',
		})}
		icon="fas fa-calculator"
		size="m"
		class="width-lg-l width-sm-full mb-s"
		info={$format('input_info_temp_override_open_window', {
			default: 'Temperature override when window is open in °C',
		})}
		bind:value={default_override_target_C}
		id="input-69crlfy"
	/>

	<Text class="mb-s" element="span" styleType="body-extra-small"
		>{$format('text_trv_setting_duration', { default: 'Duration' })}</Text
	>
	<Input
		aria-label={$format('input_info_duration_temp_override', {
			default: 'Enter the duration of the temperature override in minutes',
		})}
		icon="fas fa-calculator"
		size="m"
		class="width-lg-l width-sm-full mb-s"
		info={$format('input_info_duration_temp_override', {
			default: 'Duration of the temperature override in minutes',
		})}
		error={minMaxInfo.error}
		bind:value={default_override_duration}
		id="input-5r60a98"
	/>

	<Button
		loading={waitForResponse}
		disabled={minMaxInfo.error || waitForResponse}
		class="mt-s"
		size="m"
		width="full"
		on:click={handleOpenWindowTarget}
		>{$format('button_save_settings', {
			default: 'Save settings',
		})}</Button
	>
</div>
